import type { ReactNode } from "react";
import { Bell } from "lucide-react";
import { ProfileImage } from "./ProfileImage";
import { STUDENT_COLORS } from "./studentTheme";

export const STUDENT_HEADER_HEIGHT = 68;

/**
 * Avia Dental ヘッダー（ロゴ・お知らせ・プロフィール）。
 * 学生ホーム系の StudentMobileShell と、面接・評価など全画面の StudentAppHeader で共有する。
 */
export function StudentHeader({
  onLogoClick,
  logoLabel = "ホームへ戻る",
  srLabel,
  actions,
  showStudentIcons = true,
  profileCurrent = false,
  onProfileClick,
  maxWidth,
}: {
  onLogoClick: () => void;
  logoLabel?: string;
  /** 画面名（見出しの代わりに読み上げ用） */
  srLabel?: string;
  /** お知らせ・プロフィールの前に置く追加ボタン */
  actions?: ReactNode;
  showStudentIcons?: boolean;
  profileCurrent?: boolean;
  onProfileClick?: () => void;
  /** 中身の最大幅。未指定なら画面幅いっぱい */
  maxWidth?: number;
}) {
  return (
    <header
      style={{
        flex: "0 0 auto",
        height: STUDENT_HEADER_HEIGHT,
        background: STUDENT_COLORS.surface,
        borderBottom: `1px solid ${STUDENT_COLORS.line}`,
      }}
    >
      <div
        style={{
          maxWidth,
          height: "100%",
          margin: "0 auto",
          padding: "0 16px",
          display: "flex",
          alignItems: "center",
          gap: 14,
        }}
      >
        <button
          type="button"
          onClick={onLogoClick}
          aria-label={logoLabel}
          style={{
            border: 0,
            minWidth: 0,
            background: "transparent",
            padding: 0,
            cursor: "pointer",
          }}
        >
          <img src="/avia-logo-horizontal.png" alt="Avia Dental" style={{ display: "block", width: 210, maxWidth: "100%", height: 40, objectFit: "contain" }} />
        </button>
        {srLabel && (
          <span
            style={{
              position: "absolute",
              width: 1,
              height: 1,
              overflow: "hidden",
              clip: "rect(0 0 0 0)",
            }}
          >
            {srLabel}
          </span>
        )}
        <div style={{ flex: 1 }} />
        {actions}
        {showStudentIcons && (
          <>
            <button
              type="button"
              aria-label="お知らせ"
              style={headerIconButtonStyle}
            >
              <Bell size={18} />
            </button>
            <button type="button" aria-label="マイページ" title="マイページ" aria-current={profileCurrent ? "page" : undefined} onClick={onProfileClick} style={{ ...headerIconButtonStyle, background: STUDENT_COLORS.cyanSoft, color: STUDENT_COLORS.cyan }}>
              <ProfileImage />
            </button>
          </>
        )}
      </div>
    </header>
  );
}

const headerIconButtonStyle = {
  width: 38,
  height: 38,
  display: "grid",
  placeItems: "center",
  borderRadius: 999,
  border: 0,
  background: "transparent",
  color: STUDENT_COLORS.ink,
  flexShrink: 0,
  cursor: "pointer",
} as const;
